
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-businesses/real-estate-listings",
      function () {
        return require("private-next-pages/for-businesses/real-estate-listings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-businesses/real-estate-listings"])
      });
    }
  